export default __webpack_public_path__ + "static/media/karada_village.8d630c98.jpg";